
export interface CoreOneRosterConfigurationCombinedTeam {
    id?: string
    flowSyncType: OneRosterCombinedTeamFlowSyncType
    displayName: string
    courseTitle: string
    active?: boolean
    flowSyncGroupId?: string
    flowSyncGroupTitle?: string
    flowSyncActivityId?: string
    flowSyncActivityTitle?: string
    sources: CoreOneRosterConfigurationCombinedTeamSource[]
    schoolUnitTitle?: string
}

export interface CoreOneRosterConfigurationCombinedTeamSource {
    id?: string
    flowSyncActivityId?: string
    flowSyncGroupId?: string
    flowSyncGroupTitle?: string
    flowSyncActivityTitle?: string
    flowSyncType?: OneRosterCombinedTeamFlowSyncType,
    schoolUnitTitle?: string
}

export interface OneRosterCombineTeamListing {
    id: string
    title: string,
    schoolUnitTitle?: string
}

export enum OneRosterCombinedTeamFlowSyncType {
    Undefined = 0,
    Activity = 1,
    Group = 2,
}

export const combinedTeamFlowSyncTypes: OneRosterCombinedTeamFlowSyncType[] = [
    OneRosterCombinedTeamFlowSyncType.Activity,
    OneRosterCombinedTeamFlowSyncType.Group,
];

